import React from 'react';

const ErrorCard = ({ wrapperClassName, errorText }) => {
    return (
        <div className={wrapperClassName} style={{ padding: '10px 15px', backgroundColor: 'red', color: 'white', borderRadius: '4px' }}>
            {errorText}
        </div>
    );
};

export default ErrorCard;